<div *ngIf="dockData" [ngStyle]="{ 'background-color': bgColor}">
    <h1 class="description" [ngStyle]="{'color': activeDock ? '#FFF' : '#000'}">{{dockData.description}}</h1>
    <app-takt [takt]="takt" [bgColor]="bgColor" [ngStyle]="{'color': activeDock ? '#FFF' : '#000'}"></app-takt>
    <div *ngIf="activeDock" class="boxes">
      <div class="arrival-box">Chegada: {{extractTime(dockData.status)}}</div>
    </div>
  </div>
  <div *ngIf="!dockData">
    <p>Carregando informações da doca...</p>
  </div>